import { Component, ElementRef, HostListener, Input, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import Player from '@vimeo/player';
import { PageService } from 'src/app/services/page.service';
@Component({
    selector: 'app-home-video',
    templateUrl: './home-video.component.html',
    styleUrls: ['./home-video.component.scss']
})
export class HomeVideoComponent implements OnInit {
    @Input() content: any;
    animateContent: boolean = false;
    iframeIsLoaded: boolean = false;
    iframeIsLoadedMobile: boolean = false;
    videoprogress: number = 0;
    videourl: any;
    videourlMobile: any;
    player: Player;
    playerMobile: Player;
    notScrolled: boolean = false;
    scrolled: boolean = false;
    loadOverlay: boolean = false;
    @ViewChild('videoplayer') videoplayer: ElementRef;
    @ViewChild('videoplayerMobile') videoplayerMobile: ElementRef;
    dangerousUrl: any;
    dangerousUrlMobile: any;
    loadImage: boolean = false;
    iframeNotLoaded: boolean = false;
    not_suspend: boolean = true;
    screenWidth;

    @HostListener('window:resize', ['$event'])
    onResize() {
        this.screenWidth = window.innerWidth;
    }

    constructor(private sanitizer: DomSanitizer,
        private pageService: PageService) {
        this.pageService.scrollListen().subscribe((m: boolean) => {
            this.scrolled = true;
        })
    }

    ngOnInit() {
        this.screenWidth = window.innerWidth;
        setTimeout(() => {
            this.loadOverlay = true;
        }, 300);
        setTimeout(() => {
            if (!this.scrolled) {
                this.notScrolled = true;
            }
        }, 5000);
    }

    iframeLoaded() {
        setTimeout(() => {
            this.iframeIsLoaded = true;
            this.pageService.loadPage(this.content.title);
        }, 600);
        if (this.player) {
            var promise = this.player.play();
            if (promise !== undefined) {
                promise.then(_ => {
                }).catch(error => {
                    this.not_suspend = false;
                });
            }
        }
    }

    iframeLoadedMobile() {
        setTimeout(() => {
            this.iframeIsLoadedMobile = true;
            this.pageService.loadPage(this.content.title);
        }, 600);
        if (this.player) {
            var promise = this.player.play();
            if (promise !== undefined) {
                promise.then(_ => {
                }).catch(error => {
                    this.not_suspend = false;
                });
            }
        }
    }

    public onIntersection({ target, visible }: { target: Element; visible: boolean }): void {
        if(this.screenWidth > 1024){
            if (visible) {
                if (!this.player) {
                    var base = 'https://player.vimeo.com/video/';
                    var src = this.content.video_id + '?autoplay=0&loop=1&autopause=0&background=1&byline=0&portrait=0&muted=1';
                    this.dangerousUrl = new URL(src, base);
                    this.videourl = this.sanitizer.bypassSecurityTrustResourceUrl(this.dangerousUrl);
                    setTimeout(() => {
                        this.player = new Player(this.videoplayer.nativeElement);
                        this.player.play();
                        this.player.on('timeupdate', function (data) {
                            this.videoprogress = (data.percent * 100);
                        })
                    }, 200);
                } else {
                    this.player.play();
                    if (this.screenWidth <= 1024) {
                        this.pageService.whiteLogo(true);
                    }
                    this.player.on('timeupdate', function (data) {
                        this.videoprogress = (data.percent * 100);
                    })
                }
            } else {
                if (this.player) {
                    if (this.player.videoprogress > 0) {
                        this.player.pause();
                    }
                }
                if (this.screenWidth <= 1024) {
                    this.pageService.whiteLogo(false);
                }
            }
        } else {
            if (visible) {
                if (!this.playerMobile) {
                    var base = 'https://player.vimeo.com/video/';
                    var src = this.content.video_mobile_id + '?autoplay=0&loop=1&autopause=0&background=1&byline=0&portrait=0&muted=1';
                    this.dangerousUrlMobile = new URL(src, base);
                    this.videourlMobile = this.sanitizer.bypassSecurityTrustResourceUrl(this.dangerousUrlMobile);
                    setTimeout(() => {
                        this.playerMobile = new Player(this.videoplayerMobile.nativeElement);
                        this.playerMobile.play();
                        this.playerMobile.on('timeupdate', function (data) {
                            this.videoprogress = (data.percent * 100);
                        })
                    }, 200);
                } else {
                    this.playerMobile.play();
                    if (this.screenWidth <= 1024) {
                        this.pageService.whiteLogo(true);
                    }
                    this.playerMobile.on('timeupdate', function (data) {
                        this.videoprogress = (data.percent * 100);
                    })
                }
            } else {
                if (this.playerMobile) {
                    if (this.playerMobile.videoprogress > 0) {
                        this.playerMobile.pause();
                    }
                }
                if (this.screenWidth <= 1024) {
                    this.pageService.whiteLogo(false);
                }
            }
        }
    }
    
    @HostListener('window:scroll', ['$event'])
    onScroll(event) {
        this.scrolled = false;
        this.notScrolled = false;
    }
}
